import { APIStatus } from "@application/common/enums/api-status";
import { createSlice } from "@reduxjs/toolkit";
import { getAllArticleGroupAsync } from "./ArticleGroupThunk";
const initialState = {
    status: APIStatus.IDLE
};
export const articleGroupSlice = createSlice({
    name: 'articlegroup',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllArticleGroupAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllArticleGroupAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.articleGroups = action.payload;
            state.articleGroupDropdown = action.payload.map((group) => {
                return {
                    label: `${group.name}`,
                    value: `${group.name}`
                };
            });
        })
            .addCase(getAllArticleGroupAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default articleGroupSlice.reducer;
